import { ESdChangeReason, IConditionModel } from "@kuika/kuika-cl-model";
import { ConditionSetType, IAction } from "@kuika/kuika-cl-model/src/models/builder.dtos";
import * as React from "react";
import { ActionCondition } from "./action-condition";

export interface IIfThenElseConditionSymbolGroupState {}

export interface IIfThenElseConditionSymbolGroupProps {
  action: IAction;
  condition?: IConditionModel;
  updateCondition: (value: IConditionModel, changeReason?: ESdChangeReason | undefined) => void;
}

class IfThenElseConditionSymbolGroup extends React.Component<
  IIfThenElseConditionSymbolGroupProps,
  IIfThenElseConditionSymbolGroupState
> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.condition === undefined) {
      this.props.updateCondition({
        conditionSet: {
          conditions: [],
          type: ConditionSetType.and
        }
      } as IConditionModel);
    }
  }

  handleActionCondition = (condition: IConditionModel | undefined, changeReason?: ESdChangeReason | undefined) => {
    if (condition) {
      this.props.updateCondition(condition, changeReason);
    }
  };

  render() {
    return (
      <div style={{ width: "100%" }}>
        <ActionCondition
          action={this.props.action}
          condition={this.props.condition}
          onChange={this.handleActionCondition}
          dontShowRemoveCondition
        />
      </div>
    );
  }
}

const ifThenElseConditionSymbolGroup = IfThenElseConditionSymbolGroup;
export { ifThenElseConditionSymbolGroup as IfThenElseConditionSymbolGroup };
